















import { Component, Prop, Vue } from "vue-property-decorator";
import InfoIcon from "vue-material-design-icons/InformationOutline.vue";

@Component({
  components: {
    InfoIcon
  }
})
export default class PopoverInfo extends Vue {
  @Prop() private msg!: string;

  private show = false;
}
